let globalToken = null;
let logoutFunc = null;

async function doFetch (url, method, data) {

    if (url.substring(0,4) !== 'http') {
        url = 'https://api.toto.aptuslogic.com/index.php' + url; 
    }
    let headers = {
        'Content-Type': 'application/json',
    };

    // add access token
    if (globalToken) {
      if (method.toLowerCase() === 'get') {
        if (url.indexOf('?') !== -1) {
          url += '&token=' + globalToken;
        }
        else {
          url += '?token=' + globalToken;
        } 
      }
      else if (data) {
        data.token = globalToken;
      }  
    }

    return (new Promise (resolve => {
        fetch (url, {
          method,
          body: data ? JSON.stringify (data) : null, 
          headers: data ? new Headers (headers) : undefined,
        })
        .then (res => res.json())
        .then (resolve)
        .catch (error => {
          globalToken = null;
          if (logoutFunc) {
            logoutFunc();
          }
        });
    }));
}

export async function get (url) {
  let result = await doFetch(url, 'GET', null);
  return (result);
}

export async function post (url, data = null) {
  let result = await doFetch(url, 'POST', data);
  return (result);
}

export async function put (url, data = null) {
  let result = await doFetch(url, 'PUT', data);
  return (result);
}

export async function del (url) {
  let result = await doFetch(url, 'DELETE', null);
  return (result);
}

export function setGlobalToken (token, logoutFuncParam) {
  globalToken = token;
  logoutFunc = logoutFuncParam;
}